import React, { PropTypes } from 'react'
// import { Container } from 'react-responsive-grid'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import DocumentTitle from 'react-document-title'
import RequestDemoModal from '../components/RequestDemoModal'
import SiteFooter from '../components/SiteFooter'

import { config } from 'config'

// import Headroom from 'react-headroom'
import '../css/bootstrap'
// import '../css/markdown-styles'
import '../css/style.scss'

import { rhythm } from '../utils/typography'

// module.exports = React.createClass({
class Template extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      requestDemoModalIsOpen: false,
    };
    this._openRequestDemoModal  = this._openRequestDemoModal.bind(this);
    this._closeRequestDemoModal = this._closeRequestDemoModal.bind(this);
  }

  /* MODAL
  --===================================================-- */
  _openRequestDemoModal() {
    this.setState({requestDemoModalIsOpen: true});
  }

  _closeRequestDemoModal() {
    this.setState({requestDemoModalIsOpen: false});
  }

  render () {
    let logo = '/images/logo.svg';

    return (
      <DocumentTitle title={config.siteTitle}>
      <div className="SetterContainer">

        <RequestDemoModal
          closeTimeoutMS={150}
          isOpen={this.state.requestDemoModalIsOpen}
          onRequestClose={this._closeRequestDemoModal}
        />
        {this.props.children}

        {/*<Headroom>
          <Container>

          </Container>
        </Headroom>
        <Container
          style={{
            maxWidth: 960,
            padding: `${rhythm(1)} ${rhythm(3/4)}`,
            paddingTop: 0,
          }}
        >
          {this.props.children}
        </Container>*/}
        <SiteFooter />
      </div>
      </DocumentTitle>
    )
  }
}

Template.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
  route: PropTypes.object,
}

export default Template;



/** WEBPACK FOOTER **
 ** ./_template.js
 **/